import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { CF_APPROVAL_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/cf-approval";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getV2HeaderConfig } from "./v2-config";
import { toast } from "react-toastify";
import MuiTable from "../../../common-utilities/core/mui-table";
import { Box, CircularProgress } from "@mui/material";
import { CF_APPROVAL_COMMON_ROUTE_V2 } from "../../../cf-approval/utils/constants";
import { setPage } from "../../../../reducer/cfApprovalV2";

const LIMIT = 10;

export const CfV2FormsTable = ({ commonFilters, status, refreshKey, userMap }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const page = useSelector((state) => state.cfApprovalV2.page);
  const [formsList, setFormsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(() => {
    setLoading(true);
    const queryParams = { page, limit: LIMIT, ...commonFilters };
    if (status) queryParams.status = status;

    invokeApi(HTTP_METHODS.GET, `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_V2}`, null, queryParams)
      .then((response) => {
        if (response?.result) {
          setTotalCount(response?.total || response?.result?.length || 0);
          setFormsList(response?.result || []);
        } else {
          setFormsList([]);
        }
      })
      .catch((err) => {
        console.error("Error loading v2 forms:", err);
        toast.error("Failed to load forms");
      })
      .finally(() => setLoading(false));
  }, [page, commonFilters, status, refreshKey]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const onClick = (data, action) => {
    if (action === "view-details") {
      navigate(`${CF_APPROVAL_COMMON_ROUTE_V2}/form-details/${data.id}`);
    }
  };

  if (loading && formsList.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <MuiTable
      columnsList={getV2HeaderConfig(userMap)}
      dataList={formsList}
      filters={{ page, limit: LIMIT }}
      pageCount={Math.ceil(totalCount / LIMIT) || 1}
      onClick={onClick}
      onChange={(newPage) => dispatch(setPage(newPage))}
    />
  );
};
